<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height="24"
    width="24"
  >
    <path
      class="st1"
      d="M2,12H4V17H20V12H22V17A2,2 0 0,1 20,19H4A2,2 0 0,1 2,17V12M12,2L6.46,7.46L7.88,8.88L11,5.75V15H13V5.75L16.12,8.88L17.54,7.46L12,2Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'UploadIcon',
};
</script>

<style scoped lang="scss">
.st1 {
  fill: main.$npGray;
}
</style>
